import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'weekDate',
    standalone: false
})
export class WeekDatePipe implements PipeTransform {

  transform(value: any, isGetDayShort?: boolean, formatDayShort?: string): any {

    let date: DateTime = null;

    if (value instanceof Date)
      date = DateTime.fromJSDate(value);
    else if (typeof (value) === 'string' || value instanceof String)
      date = DateTime.fromISO(value.toString());
    else if (value instanceof DateTime)
      date = date;

    if (!date)
      return '';

    date = date.setZone(Intl.DateTimeFormat().resolvedOptions().timeZone);

    if (isGetDayShort) {
      return formatDayShort
        ? date.toFormat(formatDayShort)
        : date.toLocaleString(DateTime.DATETIME_SHORT);
    }

    return formatDayShort
      ? date.toFormat(formatDayShort)
      : date.toLocaleString(DateTime.DATETIME_SHORT);
  }

}
